
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import HomePage from '../components/HomePage';
import Head from 'next/head';
import useTranslation from 'next-translate/useTranslation';
import { useState, useEffect } from 'react';
import { cachedDataWrapper } from '../lib/dataFetcher';
import { shouldAcceptUpdate, parseTs, hasUsableData } from '../lib/freshness';
async function getStaticProps() {
    try {
        const data = await cachedDataWrapper();
        return {
            props: {
                initialData: data
            },
            revalidate: 60 // This allows incremental static regeneration
        };
    }
    catch (error) {
        console.error('Error fetching data:', error);
        return {
            props: {
                initialData: {
                    error: "Something went wrong. I'm probably working on it!"
                }
            },
            revalidate: 60 // Also for incremental static regeneration
        };
    }
}
function Home({ initialData }) {
    const { t } = useTranslation();
    const [fetchedData, setFetchedData] = useState(initialData);
    // Fetch data on the client side
    const fetchData = async () => {
        try {
            const response = await fetch('/api/fetchData'); // Assuming you have an API route for fetching data
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const data = await response.json();
            setFetchedData((prev) => {
                // The CDN can briefly serve a snapshot one ~5-min data cycle
                // behind. Ignore any poll that would move us backwards in time,
                // so a stale cached response never downgrades fresher data.
                if (!shouldAcceptUpdate(prev?.lastUpdated, data?.lastUpdated)) {
                    return prev;
                }
                // Flash only when the timestamp actually advanced on the client
                // (the server's cached lastUpdatedUpdated flag isn't reliable).
                const advanced = parseTs(data?.lastUpdated) > parseTs(prev?.lastUpdated);
                return { ...data, lastUpdatedUpdated: advanced };
            });
        }
        catch {
            // A transient poll failure must NOT blank a good number. Keep the
            // last usable value on screen; only show an error if we never had
            // one (e.g. the very first load failed).
            setFetchedData((prev) => hasUsableData(prev)
                ? prev
                : {
                    error: "Something went wrong. I'm probably already working on it!"
                });
        }
    };
    useEffect(() => {
        const fetchDataAndSetInterval = () => {
            fetchData(); // Initial data fetch - needed for update purposes because ISR rerenders only when accessed. If a long time goes by, where no one accesses it (i.e. in the middle of the night in denmark, we need a refresh)
            const intervalId = setInterval(() => {
                fetchData();
            }, 1000 * 60);
            // Cleanup the interval when the component unmounts
            return () => {
                clearInterval(intervalId);
            };
        };
        fetchDataAndSetInterval(); // Call the function to set up the interval
        // Specify an empty dependency array to ensure this effect runs only once
    }, []);
    return (<>
            <Head>
                {/* Title is rendered (localized) by HomePage via t('common:title'). */}
                <meta property="og:title" content={t('common:title')}/>
                <meta name="robots" content="all"/>
                {/* Static, localized, no live numbers: Google freezes whatever
            it crawls, so a baked-in wait time reads stale in the SERP. */}
                <meta name="description" content={t('common:initial_meta_description')}/>
                <meta property="og:description" content={t('common:initial_meta_description')}/>
                <meta charSet="utf-8"/>
                <meta name="author" content="Morten Laursen"/>
                <meta name="copyright" content="Morten Laursen"/>
                <link rel="icon" href="/favicon.ico"/>
            </Head>
            <HomePage waitTime={fetchedData?.waitTime} lastUpdated={fetchedData?.lastUpdated} error={fetchedData?.error} delayedFlights={fetchedData?.delayedFlights} summary={fetchedData?.summary} passportTimes={fetchedData?.passportTimes} graphData={fetchedData?.graphData} lastUpdatedUpdated={fetchedData?.lastUpdatedUpdated} securityOpening={fetchedData?.securityOpening} specialWarning={fetchedData?.specialWarning} timezone={fetchedData?.timezone}/>
        </>);
}
export default Home;

    async function __Next_Translate__getStaticProps__1a1723ec684__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1723ec684__ as getStaticProps }
  